import request from '@/config/axios'

export const getCmsPageList = () => request.get({ url: '/rental/cms-page/list' })
export const getCmsPage = (params: { id?: number; pageCode?: string }) =>
  request.get({ url: '/rental/cms-page/get', params })
export const createCmsPage = (data: any) => request.post({ url: '/rental/cms-page/create', data })
export const updateCmsPage = (data: any) => request.put({ url: '/rental/cms-page/update', data })
export const deleteCmsPage = (id: number) =>
  request.delete({ url: '/rental/cms-page/delete', params: { id } })
